<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="form-inline">
              <div class="row">
                <div class="col-xs-12">
                  <!-- 按鈕 -->
                  <div
                    v-if="getRoleType === 99 || getRoleType === 30"
                    class="form-group"
                  >
                    <div
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#trade-apply-store-modal"
                      v-text="'新增門市申請網址'"
                    />
                    <div
                      class="btn btn-default"
                      v-text="'批次啟用'"
                      @click="formType = !formType"
                    />
                  </div>
                </div>
                <div class="col">
                  <!-- 品牌 -->
                  <div class="form-group">
                    <multiselect
                      v-model="select.brand"
                      :options="brands"
                      :searchable="true"
                      :allow-empty="true"
                      :close-on-select="true"
                      placeholder="== 品牌 =="
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="value"
                    />
                  </div>
                  <!-- End 品牌 -->
                  <!-- 門市 -->
                  <div class="form-group">
                    <multiselect
                      v-model="select.store"
                      :options="stores"
                      :searchable="true"
                      :allow-empty="true"
                      :close-on-select="true"
                      placeholder="== 門市 =="
                      :show-labels="false"
                      :multiple="false"
                      label="label"
                      track-by="value"
                    />
                  </div>
                  <!-- End 門市 -->
                  <!-- 金流 -->
                  <div class="form-group">
                    <select class="form-control h-38" v-model="select.trade_type">
                      <option :value="999">== 金流 ==</option>
                      <option :value="720">icash Pay</option>
                    </select>
                  </div>
                  <!-- End 金流 -->
                  <!-- 申請狀態 -->
                  <div class="form-group">
                    <select class="form-control h-38" v-model="select.status">
                      <option :value="999">== 申請狀態 ==</option>
                      <option :value="0">產出網址</option>
                      <option :value="1">審核完成</option>
                      <option :value="2">已完成</option>
                    </select>
                  </div>
                  <!-- End 申請狀態 -->
                  <!-- 啟用狀態 -->
                  <div class="form-group">
                    <select class="form-control h-38" v-model="select.is_enable">
                      <option :value="999">== 啟用狀態 ==</option>
                      <option :value="0">未啟用</option>
                      <option :value="1">啟用</option>
                    </select>
                  </div>
                  <!-- End 啟用狀態 -->
                </div>
                <div class="col-auto text-right">
                  <!-- 下載報表 -->
                  <div class="btn btn-default btn-table-title" :disabled="isDownloading" @click="exportFile()">
                    <i class="fa fa-download" />
                    下載報表
                    <clip class="cliploading" :loading="isDownloading" :color="'#528BB8'" :size="'16px'" />
                  </div>
                  <!-- End 下載報表 -->
                </div>
                <div
                  v-if="formType"
                  class="col-xs-12"
                >
                  <div class="row">
                    <div class="col">
                      <div class="tips">
                        <div>
                          <span class="text-red">＊</span>
                          請注意：merchant ID 若是已有設定過，會覆蓋原先設定的 ID。
                        </div>
                        <div>
                          <span class="text-red">＊</span>
                          請選取欲批次啟用的門市（僅有產出網址狀態無法啟用）。
                        </div>
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="betch-btns">
                        <div
                          class="btn btn-default m-r-5"
                          v-text="'取消'"
                          @click="setBetch(0)"
                        />
                        <div
                          class="btn btn-success"
                          v-text="'啟用'"
                          @click="setBetch(1)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table class="table table-bordered table-striped dataTable">
                    <thead>
                      <tr role="row">
                        <th v-if="formType">
                          <input
                            type="checkbox"
                            v-model="checkBoxSelectAll"
                            @change="selectAll"
                          />
                        </th>
                        <th class="">#</th>
                        <th class="w-text">品牌</th>
                        <th class="w-text">門市（ID）</th>
                        <th class="w-text">申請狀態</th>
                        <th class="w-text">啟用</th>
                        <th class="w-url">申請網址</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, k) in list" :key="item.id">
                        <td v-if="formType">
                          <input
                            type="checkbox"
                            v-model="item.selectItem"
                          />
                        </td>
                        <!-- # -->
                        <td>{{ k + 1 }}</td>
                        <!-- 品牌 -->
                        <td>{{ item.brand_name }}</td>
                        <!-- 門市（ID） -->
                        <td>{{ item.store_name }} ({{ item.store_id }})</td>
                        <!-- 申請狀態 -->
                        <td>
                          <span class="label" :class="handleStatus(item.status).class">
                            {{ handleStatus(item.status).text }}
                          </span>
                        </td>
                        <!-- 啟用 -->
                        <td>
                          <span class="label" :class="handleIsEnable(item.is_enable).class">
                            {{ handleIsEnable(item.is_enable).text }}
                          </span>
                        </td>
                        <!-- 申請網址 -->
                        <td class="w-url">
                          <div class="row align-center">
                            <div class="col control-url">{{ item.url }}</div>
                            <div class="col-auto">
                              <button
                                class="btn btn-primary"
                                type="button"
                                v-clipboard:copy="item.url"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError"
                                v-text="'複製'"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="!list || !list.length">
                        <td colspan="12">
                          <div class="no-data">
                            <img class="center-block no-data-img" src="/static/img/noMatchdata.svg" />
                            <div v-text="'沒有符合的資料'" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <paginate
                  :clickPage="paginateClickPage"
                  :groupAmount="paginate.groupAmount"
                  :isActive="paginateIsActive"
                  :pageAmount="paginateAmount"
                  :total="paginate.total"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 門市申請網址 -->
    <nd-modal
      :option="optionConfigApplyStoreModal"
      @trigger="trigger"
    >
      <template v-slot:body>
        <nd-trade-apply-store
          :brands="brands"
          :getDataH="getDataH"
          :tradeType="select.trade_type"
          @update:choose="updateChoose"
        />
      </template>
    </nd-modal>
    <!-- End 門市申請網址 -->

    <!-- 批次啟用 -->
    <nd-modal
      :option="optionsConfCheckedBetchStore"
      @trigger="trigger"
    >
      <template v-slot:body>
        確定啟用門市？
      </template>
    </nd-modal>
    <!-- End 批次啟用 -->
  </section>
</template>

<script>
// core
import { mapGetters } from 'vuex'

// utils
import Clip from 'vue-spinner/src/ClipLoader.vue'
import moment from 'moment'

// components
import NdModal from '@/components/elements/Modal.vue'
import NdTradeApplyStore from '@/components/elements/nd-trade-apply-store.vue'

export default {
  name: 'TradeSettingView',
  components: {
    'clip': Clip,
    'nd-modal': NdModal,
    'nd-trade-apply-store': NdTradeApplyStore
  },
  data () {
    return {
      brands: [],
      checkBoxSelectAll: false,
      formType: false, // false: default, true: betch
      isDownloading: false,
      list: [],
      optionConfigApplyStoreModal: {
        id: 'trade-apply-store-modal',
        title: '門市申請網址',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'createApplyStore'
          }
        ]
      },
      optionsConfCheckedBetchStore: {
        id: 'checked-betch-store-modal',
        title: '提醒',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'setBetchStore'
          }
        ]
      },
      paginate: {
        count: 10,
        groupAmount: 10,
        page: 1,
        total: 1
      },
      query: {}, // 搜尋條件
      select: {
        brand: {
          label: '== 品牌 ==',
          value: 0
        },
        is_enable: 999,
        status: 999,
        store: {
          label: '== 門市 ==',
          value: 0
        },
        trade_type: 720
      },
      stores: [],
      tempApplyInfo: {
        brand: 0,
        store: []
      }
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getPickupType', 'getTradeType']),
    getDataH () {
      return this.$parent.getDataH
    },
    getFile () {
      return this.$parent.getFile
    },
    paginateAmount () {
      return Math.ceil(this.paginate.total / this.paginate.count)
    },
    storeIds () {
      let temp = []
      let checked = this.list.filter((i) => {
        return i.selectItem === true
      }) || []
      temp = checked.map((i) => {
        return i.store_id
      })
      return temp
    }
  },
  watch: {
    async 'select.brand.value' () {
      this.stores = []
      this.select.store.label = '== 門市 =='
      this.select.store.value = 0
      await this.getStores(this.select.brand.value)
      this.getList(1)
    },
    async 'select.is_enable' () {
      this.getList(1)
    },
    async 'select.status' () {
      this.getList(1)
    },
    async 'select.store.value' () {
      this.getList(1)
    },
    async 'select.trade_type' () {
      this.getList(1)
    }
  },
  mounted () {
    if (this.$route.query.status) this.select.status = Number(this.$route.query.status)
    if (this.$route.query.trade_type) this.select.trade_type = Number(this.$route.query.trade_type)
    if (this.$route.query.page) this.paginate.page = Number(this.$route.query.page)
    this.getBrands()
    this.getList()
  },
  methods: {
    /** 申請網址 */
    createApplyStore () {
      console.log({
        component: this.$options.name,
        function: 'createApplyStore',
        payload: {},
        time: moment().format('HH:mm:ss')
      })

      // 若沒有勾選任何參數，忽略下方執行程序
      if (!this.tempApplyInfo.store.length) {
        return
      }

      const url = '/tradeTypeBiz/create'
      const params = {
        trade_type: this.select.trade_type,
        brand_id: this.tempApplyInfo.brand,
        store_id: this.tempApplyInfo.store.join(',')
      }
      this.getDataH('post', url, params, (res) => {
        if (res.data.status === 200) {
          this.$notify({
            title: '產出完成',
            text: '已完成！',
            duration: 1000,
            type: 'success',
            width: 400
          })
          const brand = this.brands.find((i) => {
            return i.value === this.tempApplyInfo.brand
          })
          this.select.brand = brand
          this.select.status = 0
          this.getList()
        }
      })
    },
    /** 下載報表 */
    exportFile () {
      console.log({
        component: this.$options.name,
        function: 'exportFile',
        payload: {},
        time: moment().format('YYYY/MM/DD HH:mm:ss')
      })

      this.isDownloading = true
      let query = this.query
      let searchParams = ''
      if (query.page) {
        delete query.page
      }
      if (query.size) {
        delete query.size
      }
      if (Object.keys(query).length) {
        searchParams = new URLSearchParams(query)
      }
      const url = `/tradeTypeBiz/listSheets?${searchParams.toString()}`
      this.getFile('get', url, null, (res) => {
        this.isDownloading = false
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const objectUrl = URL.createObjectURL(blob)
        const el = document.createElement('a')
        el.href = objectUrl
        el.download = `icash Pay 註冊資訊_${moment().format('YYYYMMDD')}.xlsx`
        document.body.appendChild(el)
        el.click()
      })
    },
    /** 品牌 */
    getBrands () {
      const url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.brands = [{ label: '== 品牌 ==', value: 0 }]
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = { label: bList[i].name, value: bList[i].brand_id }
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            this.brands.push(obj)
          }
        }
      })
    },
    /** 列表 */
    getList (page) {
      return new Promise((resolve, reject) => {
        let url = `/tradeTypeBiz/list?size=${this.paginate.count}`
        if (page) this.paginate.page = page
        let query = {}
        // 品牌
        if (this.select.brand && this.select.brand.value) {
          if (this.$route.query.brand_id && this.$route.query.brand_id !== this.select.brand.value) this.paginate.page = 1
          query = {
            ...query,
            ...{ brand_id: this.select.brand.value }
          }
          url = url + '&brand_id=' + this.select.brand.value
        }
        // 門市
        if (this.select.store && this.select.store.value) {
          if (this.$route.query.store_id && this.$route.query.store_id !== this.select.store.value) this.paginate.page = 1
          query = {
            ...query,
            ...{ store_id: this.select.store.value }
          }
          url = url + '&store_id=' + this.select.store.value
        }
        // 金流
        if (this.select.trade_type && this.select.trade_type !== 999) {
          if (this.$route.query.trade_type && this.$route.query.trade_type !== this.select.trade_type) this.paginate.page = 1
          query = {
            ...query,
            ...{ trade_type: this.select.trade_type }
          }
          url = url + '&trade_type=' + this.select.trade_type
        }
        // 申請狀態
        if (typeof this.select.status !== 'undefined' && this.select.status !== null && this.select.status !== 999) {
          if (this.$route.query.status && this.$route.query.status !== this.select.status) this.paginate.page = 1
          query = {
            ...query,
            ...{ status: this.select.status }
          }
          url = url + '&status=' + this.select.status
        }
        // 啟用狀態
        if (typeof this.select.is_enable !== 'undefined' && this.select.is_enable !== null && this.select.is_enable !== 999) {
          if (this.$route.query.is_enable && this.$route.query.is_enable !== this.select.is_enable) this.paginate.page = 1
          query = {
            ...query,
            ...{ is_enable: this.select.is_enable }
          }
          url = url + '&is_enable=' + this.select.is_enable
        }
        // 分頁
        if (this.paginate.page) {
          query = {
            ...query,
            ...{ page: this.paginate.page }
          }
          url = url + '&page=' + this.paginate.page
        }
        this.query = query
        this.$router.replace({ query: query })
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.list = response.data.list.map((i) => {
              return {
                ...i,
                selectItem: false
              }
            })
            this.paginate.total = response.data.total
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    /** 門市 */
    getStores (brandId) {
      console.log({
        component: this.$options.name,
        function: 'getStores',
        payload: {
          brandId: brandId
        },
        time: moment().format('HH:mm:ss')
      })

      if (!brandId) return
      return new Promise((resolve, reject) => {
        this.stores = [{ label: '== 門市 ==', value: 0 }]
        const url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            const sList = response.data.list
            // 因為沒有門市導致不繼續跑訂單列表
            if (sList.length === 0) {
              this.getList()
            } else {
              for (let i = 0; i < sList.length; i++) {
                let obj = { label: sList[i].name, value: sList[i].store_id }
                this.stores.push(obj)
              }
            }
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    /** 處理啟用 */
    handleIsEnable (val) {
      let temp = {
        class: '',
        text: ''
      }
      switch (val) {
        case 0:
          temp.class = 'label-default'
          temp.text = '未啟用'
          break
        case 1:
          temp.class = 'label-success'
          temp.text = '啟用'
          break
        default:
          temp.class = 'label-default'
          temp.text = '未知'
          break
      }
      return temp
    },
    /** 處理申請狀態 */
    handleStatus (val) {
      let temp = {
        class: '',
        text: ''
      }
      switch (val) {
        case 0:
          temp.class = 'label-default'
          temp.text = '產出網址'
          break
        case 1:
          temp.class = 'label-primary'
          temp.text = '審核完成'
          break
        case 2:
          temp.class = 'label-success'
          temp.text = '已完成'
          break
        default:
          temp.class = 'label-default'
          temp.text = '未知'
          break
      }
      return temp
    },
    /** 複製成功 */
    onCopy () {
      this.$notify({
        title: '提示',
        text: '複製成功！',
        duration: 1000,
        type: 'success',
        width: 400
      })
    },
    /** 複製失敗 */
    onError () {
      this.$notify({
        title: '提示',
        text: '複製失敗！',
        duration: 1000,
        type: 'danger',
        width: 400
      })
    },
    /** 換頁 */
    paginateClickPage (index) {
      this.paginate.page = index
      this.getList()
    },
    /** 是否為當下頁碼 */
    paginateIsActive (index) {
      if (Number(this.paginate.page) === index) return true
      else return false
    },
    selectAll () {
      this.list = this.list.map((i) => {
        return {
          ...i,
          selectItem: this.checkBoxSelectAll
        }
      })
    },
    /** 設定批次啟用 */
    setBetch (type) {
      if (type === 1) {
        window.$('#checked-betch-store-modal').modal('show')
      } else {
        this.formType = false
      }
    },
    /**
     * 批次啟用金流
     *
     * 管理員使用，批次啟用金流
     */
    setBetchStore () {
      console.log({
        component: this.$options.name,
        function: 'setBetchStore',
        payload: {},
        time: moment().format('HH:mm:ss')
      })

      // 若沒有勾選任何參數，忽略下方執行程序
      if (!this.storeIds.length) {
        this.formType = false
        return
      }

      const url = '/tradeTypeBiz/batchEnable'
      const params = {
        trade_type: this.select.trade_type,
        store_id: this.storeIds.join(',')
      }
      this.getDataH('post', url, params, (res) => {
        if (res.data.status === 200) {
          this.$notify({
            title: '啟用成功',
            text: '已啟用成功！',
            duration: 1000,
            type: 'success',
            width: 400
          })
          this.formType = false
          this.getList()
        }
      })
    },
    trigger (event) {
      if (event === 'createApplyStore') {
        this.createApplyStore()
      } else if (event === 'setBetchStore') {
        this.setBetchStore()
      } else {
        console.log('trigger', event)
      }
    },
    updateChoose (payload) {
      console.log({
        component: this.$options.name,
        function: 'updateChoose',
        payload: payload,
        time: moment().format('HH:mm:ss')
      })
      this.tempApplyInfo.brand = payload.brand
      this.tempApplyInfo.store = payload.store
    }
  }
}
</script>

<style lang="scss" scoped>
.betch-btns {
  height: 100%;
  display: flex;
  align-items: end;
  margin-left: 64px;
}
.col {
  flex: 1 0 0%;
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
}
.control-url {
  height: 10rem;
  overflow-y: scroll;
}
.w-text {
  width: 80px;
}
.w-url {
  max-width: 600px;
}
.no-data {
  padding: 10rem;
  text-align: center;
}
.no-data-img {
  width: 148px;
  margin-bottom: 1rem;
}
.row {
  display: flex;
  flex-wrap: wrap;
}
.tips {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid var(--neutral-color-textgray-05, #DEDEDE);
  background: #FFF;
}
</style>



// WEBPACK FOOTER //
// TradeSetting.vue?51d1061e